<template>
  <section class="wh_container">
    <div class="wh_content_all">
      <div class="wh_top_changge">
        <li class="wh_content_li">{{ dateTop }}</li>
        <li @click="PreMonth(myDate, false)" class="li_btn">
          <div class="wh_jiantou1">
            <i class="iconfont icon-jiantou1"></i>
          </div>
        </li>
        <li @click="NextMonth(myDate, false)" class="li_btn">
          <div class="wh_jiantou2">
            <i class="iconfont icon-jiantoudown"></i>
          </div>
        </li>
      </div>
      <!-- <div class="wh_content">
        <div
          class="wh_content_item"
          v-for="(tag, index) in textTop"
          :key="index"
        >
          <div class="wh_top_tag">{{ tag }}</div>
        </div>
      </div> -->
      <div class="wh_content_box">
        <div class="wh_content">
          <div
            class="wh_content_item"
            v-for="(item, index) in list"
            :key="index"
            @click="clickDay(item, index)"
          >
            <div
              class="wh_item_date"
              v-bind:class="[
                { wh_isMark: item.isMark },
                { wh_other_dayhide: item.otherMonth !== 'nowMonth' },
                { wh_want_dayhide: item.dayHide },
                { wh_isToday: item.isToday },
                { wh_chose_day: item.chooseDay },
                { wh_sda:item.tob },
                setClass(item),
              ]"
            >
              {{ item.id }}
            </div>
            <!-- <div class="yuandian_Box">
              <div
                class="yuandian"
                v-bind:class="[
                  { wh_isMark: item.isMark },
                  { wh_other_dayhide: item.otherMonth !== 'nowMonth' },
                  { wh_want_dayhide: item.dayHide },
                  { wh_isToday: item.isToday },
                  { wh_chose_day: item.chooseDay },
                  setClass(item),
                ]"
              ></div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="mbox" style="padding-bottom: 0.3rem; margin-top: 0.4rem">
        <div><span></span>已打卡</div>
        <div><span></span>已错过</div>
        <div><span></span>未打卡</div>
      </div>
    </div>
  </section>
</template>


<script>
import timeUtil from "./calendar";
export default {
  data() {
    return {
      myDate: [],
      list: [],
      historyChose: [],
      dateTop: "",
    };
  },
  props: {
    markDate: {
      type: Array,
      default: () => [],
    },
    markDateMore: {
      type: Array,
      default: () => [],
    },
    textTop: {
      type: Array,
      default: () => ["一", "二", "三", "四", "五", "六", "日"],
    },
    sundayStart: {
      type: Boolean,
      default: () => false,
    },
    agoDayHide: {
      type: String,
      default: `0`,
    },
    futureDayHide: {
      type: String,
      default: `2554387200`,
    },
  },
  created() {
    this.intStart();
    this.myDate = new Date();
  },
  methods: {
    intStart() {
      timeUtil.sundayStart = this.sundayStart;
    },
    setClass(data) {
      let obj = {};
      obj[data.markClassName] = data.markClassName;
      return obj;
    },
    clickDay: function (item) {
      if (item.otherMonth === "nowMonth" && !item.dayHide) {
        this.getList(this.myDate, item.date);
      }
      if (item.otherMonth !== "nowMonth") {
        item.otherMonth === "preMonth"
          ? this.PreMonth(item.date)
          : this.NextMonth(item.date);
      }
    },
    ChoseMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = new Date(date);
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    PreMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "preMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    NextMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date);
      this.myDate = timeUtil.getOtherMonth(this.myDate, "nextMonth");
      this.$emit("changeMonth", timeUtil.dateFormat(this.myDate));
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay);
      } else {
        this.getList(this.myDate);
      }
    },
    forMatArgs: function () {
      let markDate = this.markDate;
      let markDateMore = this.markDateMore;
      markDate = markDate.map((k) => {
        return timeUtil.dateFormat(k);
      });
      markDateMore = markDateMore.map((k) => {
        k.date = timeUtil.dateFormat(k.date);
        return k;
      });
      return [markDate, markDateMore];
    },
    getList: function (date, chooseDay) {
      const [markDate, markDateMore] = this.forMatArgs();
      this.dateTop = `${date.getFullYear()}年${date.getMonth() + 1}月`;
      let arr = timeUtil.getMonthList(this.myDate);
      for (let i = 0; i < arr.length; i++) {
        let markClassName = "";
        let k = arr[i];
        k.chooseDay = false;
        const nowTime = k.date;
        const t = new Date(nowTime).getTime() / 1000;
        //看每一天的class
        for (const c of markDateMore) {
          if (c.date === nowTime) {
            markClassName = c.className || "";
          }
        }
        //标记选中某些天 设置class
        k.markClassName = markClassName;
        k.isMark = markDate.indexOf(nowTime) > -1;
        //无法选中某天
        k.dayHide = t < this.agoDayHide || t > this.futureDayHide;
        if (k.isToday) {
          this.$emit("isToday", nowTime);
        }
        let flag = !k.dayHide && k.otherMonth === "nowMonth";
        if (chooseDay && chooseDay === nowTime && flag) {
          this.$emit("choseDay", nowTime);
          this.historyChose.push(nowTime);
          k.chooseDay = true;
        } else if (
          this.historyChose[this.historyChose.length - 1] === nowTime &&
          !chooseDay &&
          flag
        ) {
          k.chooseDay = true;
        }
      }
      this.list = arr;
      this.time(this.list)
    },
    time(list){
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth();//得到月份
      var date = now.getDate();//得到日期
      var time
      if(Number(month) + 1 > 9){
        time = year + '/' + ( (Number(month) + 1))+ '/' + date
      }else {
         time = year + '/' + (('0' + (Number(month) + 1) ) )+ '/' + date
      }
      var strs1 = new Date(time)
      list.forEach((item,index) =>{
        this.list[index].tob = false
        if(item.markClassName != ''){
          var strs2 = new Date(item.date)
          if(strs1.getTime() < strs2.getTime()){
            this.list[index].tob = true
          }
        }
      })
    }
  },
  mounted() {
    this.getList(this.myDate);
  },
  watch: {
    markDate: {
      handler() {
        this.getList(this.myDate);
      },
      deep: true,
    },
    markDateMore: {
      handler() {
        this.getList(this.myDate);
      },
      deep: true,
    },
    agoDayHide: {
      handler() {
        this.getList(this.myDate);
      },
      deep: true,
    },
    futureDayHide: {
      handler() {
        this.getList(this.myDate);
      },
      deep: true,
    },
    sundayStart: {
      handler() {
        this.intStart();
        this.getList(this.myDate);
      },
      deep: true,
    },
  },
};
</script>


<style lang="less" scoped>
@media screen and (min-width: 460px) {
  // .wh_item_date:hover {
  //   background: #ff8673;
  //   color: #fff;
  //   cursor: pointer;
  // }
}
* {
  margin: 0;
  padding: 0;
}

.wh_container {
  max-width: 410px;
  margin: auto;
}

li {
  list-style-type: none;
}
.wh_top_changge {
  display: flex;
  border-bottom: 1px solid #f4f4f4;
}

.wh_top_changge li {
  cursor: pointer;
  display: flex;
  font-size: 1.25rem;
  font-family: "PingFang SC";
  font-weight: 500;
  color: #5f6061;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 47px;
}

.wh_top_changge .wh_content_li {
  cursor: auto;
  flex: 2.5;
}
.wh_content_all {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
  padding-bottom: 8px;
}

.wh_content {
  display: flex;
  flex-wrap: wrap;
  padding: 0 3% 0 3%;
  width: 100%;
}

.wh_content:first-child .wh_content_item_tag,
.wh_content:first-child .wh_content_item {
  color: #ddd;
  font-size: 16px;
}

.wh_content_item,
wh_content_item_tag {
  font-size: 15px;
  width: 13.4%;
  text-align: center;
  color: #a4a4a4;
  position: relative;
}
.wh_content_item {
  height: 40px;
}

.wh_top_tag {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wh_item_date {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 40px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9375rem;
  font-family: "PingFang SC";
  font-weight: 400;
  color: #a4a4a4;
}

.wh_jiantou1 {
  // width: 0.75rem;
  // height: 0.75rem;
  // border-top: 0.125rem solid #a4a4a4;
  // border-right: 0.125rem solid #a4a4a4;
  // transform: rotate(-45deg);
}

.wh_jiantou1:active,
.wh_jiantou2:active {
  border-color: #ddd;
}

.wh_jiantou2 {
  // width: 0.75rem;
  // height: 0.75rem;
  // border-bottom: 0.125rem solid #a4a4a4;
  // border-right: 0.125rem solid #a4a4a4;
  // transform: rotate(45deg);
}
.wh_content_item > .wh_isMark {
  margin: auto;
  border-radius: 100px;
  /* background: blue; */
  color: #ff8673;
  z-index: 2;
}
.wh_content_item .wh_other_dayhide {
  font-size: 0.9375rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #dadada;
}
.wh_content_item .wh_want_dayhide {
  color: #bfbfbf;
}
.wh_content_item .wh_isToday {
  background: #ff8673;
  border-radius: 6.25rem;
  color: #fff;
}

.wh_content_item .wh_chose_day {
  // background: #ff8673;
  // color: #fff;
  border-radius: 100px;
}

.yuandian_Box {
  display: flex;
  justify-content: center;
  align-items: center;
  .noCard {
    margin-top: -0.6125rem;
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 50%;
    background: #ffad00;
  }
  .wh_isMark {
    margin-top: -0.6125rem;
    width: 0.25rem;
    height: 0.25rem;
    background: #2eca4f;
    border-radius: 50%;
  }
  .wh_isToday {
    margin-top: -0.6125rem;
    width: 0.25rem;
    height: 0.25rem;
    background: #fff;
    border-radius: 50%;
  }
}

.wh_top_changge .li_btn {
  width: 1.25rem;
  flex: none;
  margin: 0 1.125rem;
}

.wh_content {
  // text-align: center;
  padding: 0;
  margin-left: 1.3125rem;
}

.wh_content_box {
  padding: 1.6875rem 0;
  display: flex;
  justify-items: center;
  align-items: center;
}
// .yuandian {
//   margin-top: -0.6125rem;
//   width: 0.25rem;
//   height: 0.25rem;
//   background: #ff8673;
//   border-radius: 50%;
// }

// .yuandian_Box {
//   .wh_isToday {
//     background-color: #ff8673;
//   }
// }

// .yuandian_Box {
//   .wh_isToday.wh_isMark {
//     background-color: #fff;
//   }
// }

.yuandian_Box {
  display: flex;
  justify-content: center;
  align-items: center;
  .noCard {
    width: 6px;
    height: 6px;
    background: #ffad00;
    border-radius: 50%;
  }
  .wh_isMark {
    width: 6px;
    height: 6px;
    background: #2eca4f;
    border-radius: 50%;
  }
  .wh_isToday {
    width: 6px;
    //margin-top: -10px;
    height: 6px;
    // background: #ffad00;
    border-radius: 50%;
  }
}
.wh_content_item .wh_isToday {
  // width: 50px;
  // height: 50px;
  color: #a4a4a4;
  background: rgba(255, 173, 0, 0.1);
  border-radius: 50%;
}

.wh_item_date,
.wh_isMark {
  margin-top: 5px !important;
}

.wh_content_item > .wh_sda {
  background: rgba(0, 0, 0, 0.2);
}

.wh_isMark {
  // margin: auto !important;
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 50% !important;
  background: #24bf9d !important;
  color: #fff !important;
  z-index: 2 !important;
}
.noCard {
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 50% !important;
  background: #fa5151;
  color: #fff ;
  z-index: 2 !important;
}

.wh_sda{
    background: rgba(0,0,0,.1) !important;
}

.mbox {
  display: flex;
  width: 60%;
  margin: 0 auto;
  justify-content: space-around;
  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  span {
    width: 1rem;
    height: 1rem;
    display: block;
    border-radius: 50%;
    margin-right: 0.1rem;
  }
  div:nth-child(1) span {
    background: #2eca4f;
  }
  div:nth-child(2) span {
    background: rgba(250, 81, 81);
  }
  div:nth-child(3) span {
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>